import { render, staticRenderFns } from "./DoubleRangeSlider.vue?vue&type=template&id=38983a48&scoped=true&"
import script from "./DoubleRangeSlider.vue?vue&type=script&lang=js&"
export * from "./DoubleRangeSlider.vue?vue&type=script&lang=js&"
import style0 from "./DoubleRangeSlider.vue?vue&type=style&index=0&id=38983a48&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38983a48",
  null
  
)

export default component.exports